import { useMemo } from 'react';
import type { TrackingEvent, EventType } from '../../../utils/analytics';

interface StatsOverviewProps {
  events: TrackingEvent[];
}

interface StatCard {
  type: EventType | 'all';
  label: string;
  icon: string;
  color: string;
  bg: string;
}

const CARDS: StatCard[] = [
  { type: 'page_view',       label: 'Visite',           icon: 'ri-eye-line',         color: 'text-[#A5A5A5]',   bg: 'bg-[#A5A5A5]/10' },
  { type: 'whatsapp_click',  label: 'Click WhatsApp',   icon: 'ri-whatsapp-fill',    color: 'text-green-500',   bg: 'bg-green-500/10' },
  { type: 'phone_click',     label: 'Click Telefono',   icon: 'ri-phone-fill',       color: 'text-[#7FCDCD]',   bg: 'bg-[#7FCDCD]/10' },
  { type: 'preventivo_cta',  label: 'Click CTA',        icon: 'ri-cursor-fill',      color: 'text-amber-500',   bg: 'bg-amber-500/10' },
  { type: 'form_submit',     label: 'Form inviati',     icon: 'ri-send-plane-fill',  color: 'text-orange-500',  bg: 'bg-orange-500/10' },
];

export default function StatsOverview({ events }: StatsOverviewProps) {
  const today = new Date().toISOString().slice(0, 10);

  const counts = useMemo(() => {
    const total: Record<string, number> = {};
    const todayCount: Record<string, number> = {};
    events.forEach((e) => {
      total[e.type] = (total[e.type] ?? 0) + 1;
      if (e.date === today) todayCount[e.type] = (todayCount[e.type] ?? 0) + 1;
    });
    return { total, todayCount };
  }, [events, today]);

  const totalAll = events.length;
  const todayAll = events.filter((e) => e.date === today).length;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      {/* Total card */}
      <div className="col-span-2 lg:col-span-1 bg-white rounded-2xl border border-[#E5E5E5] p-5 flex flex-col gap-1">
        <div className="w-9 h-9 flex items-center justify-center bg-[#000000]/5 rounded-xl mb-2">
          <i className="ri-bar-chart-2-fill text-[#000000] text-lg" />
        </div>
        <div className="text-2xl font-black text-[#000000]" style={{ fontFamily: "'Raleway', sans-serif" }}>
          {totalAll}
        </div>
        <div className="text-xs font-semibold text-[#A5A5A5]">Tutti gli eventi</div>
        <div className="text-xs text-[#7FCDCD] font-bold mt-1">+{todayAll} oggi</div>
      </div>

      {CARDS.map((card) => {
        const total = counts.total[card.type] ?? 0;
        const today = counts.todayCount[card.type] ?? 0;
        return (
          <div key={card.type} className="bg-white rounded-2xl border border-[#E5E5E5] p-5 flex flex-col gap-1">
            <div className={`w-9 h-9 flex items-center justify-center ${card.bg} rounded-xl mb-2`}>
              <i className={`${card.icon} ${card.color} text-lg`} />
            </div>
            <div className="text-2xl font-black text-[#000000]" style={{ fontFamily: "'Raleway', sans-serif" }}>
              {total}
            </div>
            <div className="text-xs font-semibold text-[#A5A5A5]">{card.label}</div>
            <div className={`text-xs font-bold mt-1 ${card.color}`}>+{today} oggi</div>
          </div>
        );
      })}
    </div>
  );
}
